// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-session-dialog {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.register-session-dialog .loading {
  display: flex;
  justify-content: center;
  padding: 2rem;
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/_purpose-built-components/checkout-register-session/checkout-register-session-dialog.component.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AACJ","sourcesContent":[".register-session-dialog\n  display: flex\n  flex-direction: column\n  gap: 1rem\n\n  .loading\n    display: flex\n    justify-content: center\n    padding: 2rem\n    font-size: 2rem\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
